module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelCamera
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true",
      "tabindex": "-1"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('p', {
      staticStyle: {
        "margin-bottom": "0px"
      }
    }, [_c('b', [_vm._v("Stregkode:")]), _vm._v(" " + _vm._s(_vm.finalResult))]), _vm._v(" "), _c('p', {
      staticClass: "green-color",
      class: {
        'visibility': !_vm.finalResult
      },
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v("Stregkode på " + _vm._s(_vm.finalResult.length) + " cifre scannet!")]), _vm._v(" "), _c('div', {
      staticClass: "viewport",
      attrs: {
        "id": "interactive"
      }
    }, [_c('video', {
      attrs: {
        "id": "video"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-line"
    }, [_c('hr')])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "grid-x"
    }, [_c('div', {
      staticClass: "small-6 cell",
      staticStyle: {
        "padding-right": "4px"
      }
    }, [_c('a', {
      staticClass: "button",
      attrs: {
        "data-toggle": "barcodeModal",
        "aria-controls": "barcodeModal"
      },
      on: {
        "click": _vm.cancelCamera
      }
    }, [_vm._v("Annuller")])]), _vm._v(" "), _c('div', {
      staticClass: "small-6 cell",
      staticStyle: {
        "padding-left": "4px"
      }
    }, [_c('a', {
      staticClass: "button call-to-action",
      attrs: {
        "data-toggle": "barcodeModal",
        "aria-controls": "barcodeModal"
      },
      on: {
        "click": _vm.stopCamera
      }
    }, [_vm._v("Brug stregkode")])])])]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-712f8702","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 1012
// module chunks = 1